import {useEffect} from 'react';

const useEnterKeyPress = (callback, disabled = false) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && !disabled) {
        callback();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [callback, disabled]);
};

export default useEnterKeyPress;
